import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  readonly breakpointObserver = inject(BreakpointObserver);

  // based on Bootstrap's breakpoints
  public readonly breakpoints = {
    small: '576px',
    medium: '768px',
    large: '992px',
    extraLarge: '1200px',
  };

  public isMobile$: Observable<boolean> = this.breakpointObserver
    .observe(`(max-width: ${this.breakpoints.small})`)
    .pipe(map(result => result.matches));

  public isTablet$: Observable<boolean> = this.breakpointObserver
    .observe(`(min-width: ${this.breakpoints.medium})`)
    .pipe(map(result => result.matches));

  public isTabletOrMobile$: Observable<boolean> = this.breakpointObserver
    .observe(`(max-width: ${this.breakpoints.large})`)
    .pipe(map(result => result.matches));

  public isDesktop$: Observable<boolean> = this.breakpointObserver
    .observe(`(min-width: ${this.breakpoints.large})`)
    .pipe(map(result => result.matches));

  public extraLarge$: Observable<boolean> = this.breakpointObserver
    .observe(`(min-width: ${this.breakpoints.extraLarge})`)
    .pipe(map(result => result.matches));
    
}
